import * as React from 'react';

function SvgHelpVideo(props) {
  return (
    <svg width={11} height={10} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.938 2.543l-1.5.863V1.625a.75.75 0 00-.75-.75H.75a.75.75 0 00-.75.75v6.75c0 .414.336.75.75.75h6.938a.75.75 0 00.75-.75V6.594l1.5.863a.375.375 0 00.562-.323V2.867a.375.375 0 00-.563-.324zm-6.844.582A.094.094 0 013 3.219H1.687a.094.094 0 01-.093-.094v-.563c0-.051.042-.093.093-.093H3c.052 0 .094.042.094.094v.562zm6.562 3.2l-1.219-.702V4.378l1.22-.702v2.648z"
        fill="#99B9FF"
      />
    </svg>
  );
}

export default SvgHelpVideo;
